import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Users, Clock, ShieldCheck } from 'lucide-react';

const regioni = ['Veneto', 'Lombardia', 'Piemonte', 'Trentino Alto Adige', 'Friuli Venezia Giulia', 'Emilia Romagna', 'Liguria', 'Toscana', 'Marche'];

const vantaggi = [
  { icon: MapPin, text: 'Sopralluoghi gratuiti nella tua zona' },
  { icon: Users, text: 'Team locali qualificati e certificati' },
  { icon: Clock, text: 'Interventi rapidi e programmati' },
  { icon: ShieldCheck, text: 'Stessi standard di qualità in tutte le regioni' },
];

const ZoneSection = () => (
  <section id="zone" className="py-24 md:py-32 bg-slate-50" data-testid="zone-section">
    <div className="max-w-7xl mx-auto px-6 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
        <span className="text-[#FF5722] text-sm font-semibold uppercase tracking-wider">Più vicini a te</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-3 mb-4">Siamo operativi in tutto il Nord e Centro Italia</h2>
        <p className="text-slate-500 mb-8">Portiamo la nostra esperienza e la qualità dei nostri servizi direttamente nella tua regione, con un team di professionisti sempre al tuo fianco.</p>
        <div className="space-y-4 mb-8">
          {vantaggi.map((v) => (
            <div key={v.text} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0"><v.icon className="w-5 h-5 text-emerald-600" /></div>
              <span className="text-slate-700 font-medium text-sm">{v.text}</span>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap gap-2">
          {regioni.map((r) => (
            <span key={r} className="px-3.5 py-1.5 bg-white border border-slate-200 rounded-full text-xs font-semibold text-slate-700">{r}</span>
          ))}
        </div>
      </motion.div>
      <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}>
        <img src="/brochure/mappa-italia.jpg" alt="Mappa delle zone operative: Nord e Centro Italia" loading="lazy" className="rounded-2xl shadow-xl w-full object-cover" />
        <p className="text-xs text-slate-400 mt-3 text-center">Dalla montagna al mare, la stessa passione: proteggere la tua casa.</p>
      </motion.div>
    </div>
  </section>
);

export default ZoneSection;
